import { Box } from '@chakra-ui/react';
import { DeliveryOrderItem } from '@diamond/shared/types';

import { ReasonAlertBox } from './ReasonAlertBox';
import { OrderItemQuantityMetaMap, ReasonAlertItem } from './types';
import {
  formatOrderItemQuantity,
  groupItemsByReason,
  resolveOrderItemUnit,
} from './utils';

export interface PodReasonsSectionProps {
  items: DeliveryOrderItem[];
  orderItemMetaById?: OrderItemQuantityMetaMap;
}

/**
 * Displays POD (Proof of Delivery) rejection reasons for DO items
 * Shows red alert boxes grouped by rejection reason (e.g., "Rusak", "Salah kirim")
 */
export function PodReasonsSection({
  items,
  orderItemMetaById,
}: PodReasonsSectionProps) {
  const itemsWithReason = items.filter((item) => item.pod_reason);
  if (itemsWithReason.length === 0) return null;

  const mappedItems: ReasonAlertItem[] = itemsWithReason.map((item) => ({
    // POD quantities are stored magnified from backend, normalize for display.
    quantity: formatOrderItemQuantity(
      item.ordered_quantity,
      orderItemMetaById?.[item.order_item_id]
    ),
    product_name: item.product_name,
    sales_unit: resolveOrderItemUnit(
      orderItemMetaById?.[item.order_item_id],
      item.sales_unit
    ),
  }));
  const reasons = itemsWithReason.map((item) => item.pod_reason);
  const groupedByReason = groupItemsByReason(mappedItems, reasons);

  return (
    <Box mt={2} data-testid="pod-reasons-section">
      <ReasonAlertBox groupedItems={groupedByReason} />
    </Box>
  );
}
